function handleCartEvents(event) {
  const items = event?.detail?.cart?.items || event?.detail?.items || [];
  const shadowRoot = document.getElementById('opus-shadow-container')?.shadowRoot;

  const targetItem = items.find(
    (item) => item.product_id === 7446093496414 && (item.quantity >= 2)
  );


  const checkoutBtn = shadowRoot.getElementById("opus-checkout-btn-2") || document.getElementById("opus-checkout-btn-2")

  if (checkoutBtn) {
    if (targetItem) {
      checkoutBtn.style.pointerEvents = "none";
      checkoutBtn.style.opacity = "0.5"; 
      checkoutBtn.setAttribute("disabled", "true");
    } else {
      checkoutBtn.style.pointerEvents = "auto";
      checkoutBtn.style.opacity = "1";
      checkoutBtn.removeAttribute("disabled");
    }
  }
}

window.addEventListener("OpusCartChange", handleCartEvents);
window.addEventListener("OpusOpenCartState", handleCartEvents);
